import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@nexus/fff-ui-shared/Modal';
import Button from '@nexus/fff-ui-shared/Button';

import moment from 'moment-timezone';
import cookie, { COOKIE_NAMES } from 'utils/cookie';

import styles from './NoCheckoutRequiredModal.module.scss';

const NoCheckoutRequiredModal = ({ isOpen, closeModal, campaignEndDate }) => {
  const cookieName = COOKIE_NAMES.noCheckoutRequired;
  const isCookiePresent = cookie.get(cookieName);
  const date = moment(campaignEndDate).tz('America/Los_Angeles');
  const monthDay = date.format('MMMM D');

  const onClose = () => {
    if (!isCookiePresent) cookie.set(cookieName, true, 365);
    closeModal();
  };

  return (
    <Modal isOpen={isOpen} className={styles.modal}>
      <div className={styles.container}>
        <div className={styles.icon}>
          <i className="fal fa-check-circle" />
        </div>
        <h1>No Checkout Required</h1>
        <p>
          Reminder, by adding items to your cart you are agreeing to purchase
          those items if they remain in your cart at the close of the sale on{' '}
          {monthDay}. Add or remove items as often as you like while the sale is
          open. Once the sale closes, the items you selected will be
          automatically charged to the payment method on file for your account.
        </p>
      </div>
      <div className={styles.buttonContainer}>
        <Button
          onClick={onClose}
          width="100%"
          dataTestId="no-checkout-required-btn"
        >
          GOT IT, THANKS!
        </Button>
      </div>
    </Modal>
  );
};

NoCheckoutRequiredModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  campaignEndDate: PropTypes.string.isRequired,
};

export default NoCheckoutRequiredModal;
